export const IS_SERVER = typeof window === 'undefined'

export const IS_DEV = (IS_SERVER && process.env.ENV === 'dev') || process.env.APP_ENV === 'dev'
export const IS_STAGING = (IS_SERVER && process.env.ENV === 'staging') || process.env.APP_ENV === 'staging'
export const IS_PRODUCTION = (IS_SERVER && process.env.ENV === 'prod') || process.env.APP_ENV === 'production'
